import React, {useEffect, useState} from 'react'
import {Helmet} from 'react-helmet'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import useMultiSite from '../../hooks/use-multi-site'
import {useNonce} from '../../hooks'
import useEffectEvent from '../../hooks/use-effect-event'
import {isHydrated} from '../../utils/utils'

// not 'Cookiebot': an element id is a window global that shadows the API until uc.js runs
const SCRIPT_ID = 'cookiebot-script'
const SRC = 'https://consent.cookiebot.com/uc.js'

const CookieBot = () => {
    const {site} = useMultiSite()
    const nonce = useNonce()
    const enableCookiebot = site?.gdpr?.enableCookiebot || false
    const cookiebotID = getConfig().app.cookiebotAPI.cookiebotId
    const cookiebotRegions = site?.gdpr?.cookiebotRegions || ''
    // React never executes a script tag it creates, so render the tag only in the SSR markup
    // - true in the app: CookieBot mounts during hydration
    // - false only for a mount after hydration (tests, remount after an error boundary reset)
    // - no setter: a change would make React remove the tag after hydration
    const [inServerMarkup] = useState(() => !isHydrated())

    // fallback for a mount after hydration
    const onMount = useEffectEvent(() => {
        if (!enableCookiebot || document.getElementById(SCRIPT_ID)) {
            return
        }

        const script = document.createElement('script')
        script.id = SCRIPT_ID
        script.async = true
        script.src = SRC
        script.setAttribute('data-cbid', cookiebotID)
        script.setAttribute('data-georegions', cookiebotRegions)
        script.nonce = nonce
        document.head.appendChild(script)
    })
    useEffect(
        () => {
            onMount()
        },
        // intentionally no deps, as we can't change the script once it's loaded
        [onMount]
    )

    if (!enableCookiebot) {
        return null
    }

    return (
        <>
            <Helmet>
                <link rel="preconnect" href="https://consent.cookiebot.com" />
                <link rel="preconnect" href="https://consentcdn.cookiebot.com" />
            </Helmet>
            {/* rendered here and not with Helmet, which would add the script again on the client
                and load it twice; data-blockingmode is left unset because Cookiebot's automatic
                cookie blocking breaks the Adyen card payment fields */}
            {inServerMarkup && (
                <script
                    id={SCRIPT_ID}
                    async
                    src={SRC}
                    data-cbid={cookiebotID}
                    data-georegions={cookiebotRegions}
                    nonce={nonce}
                />
            )}
        </>
    )
}

export default CookieBot
